// extracted by mini-css-extract-plugin
export var expandingMenuWrapperStyle = "rsc_hb_nav_expanding_menu-module--expandingMenuWrapperStyle--hX1cw";
export var isVisibleStyle = "rsc_hb_nav_expanding_menu-module--isVisibleStyle--MMNcT";
export var itemWrapperStyle = "rsc_hb_nav_expanding_menu-module--itemWrapperStyle--t5PHm";